import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Alert } from 'antd';
import './SendingRestrictedBanner.scss';

const SUPPORT_EMAIL = 'support@2way.app';

// Shown on every page while 2way staff have paused sending on the account
// (accounts/current -> sendingRestrictedAt). Nothing is sent until they lift it.
const SendingRestrictedBanner = ({intl, sendingRestrictedAt}) => {
    if (!sendingRestrictedAt) return null;
    const t = (id, defaultMessage) => intl.formatMessage({id, defaultMessage});

    return (
        <Alert
            className="sending-restricted-banner"
            type="error"
            showIcon
            role="alert"
            message={t('sendingRestricted.title', 'Sending is paused on your account')}
            description={(
                <>
                    {t('sendingRestricted.text', 'Messages and campaigns won\'t go out. Contact 2way support to have it lifted.')}
                    {' '}
                    <a href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(t('sendingRestricted.mailSubject', 'Sending paused on my account'))}`}>
                        {t('sendingRestricted.contact', 'Contact support')}
                    </a>
                </>
            )}
        />
    );
};

const mapStateToProps = ({accounts}) => ({sendingRestrictedAt: accounts.sendingRestrictedAt});
export default connect(mapStateToProps)(injectIntl(SendingRestrictedBanner));
